import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'

export interface IApiLog {
    access_key: string
    balance?: number
    created_at: number
    exchange?: string
    id: string
    is_active?: boolean
    user?: {
        id: string
        name: string
        thumbnail: string
    }
}

export const getApiLog = async (
    size: number = 10,
    current: number = 1,
    exchange: string,
): Promise<ApiRes<IApiLog[]>> => {
    return await apiGet(API_URL, `admin/keys?page_size=${size}&current_page=${current}&exchange=${exchange}`)
}
